module.exports = __webpack_public_path__ + "static/media/grayBookSmall.101485c5.png";